module.exports = __webpack_public_path__ + "static/media/bebe1.2de2e227.jpg";